export default __webpack_public_path__ + "static/team1-0292db885eb4bd4c1a42d961dc1d09d7.jpg";